import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useDeleteMaterialTypeMutation = (
  options?: UseMutationOptions<void, unknown, number>
) => {
  return useMutation({
    ...options,
    mutationFn: async (materialId) => {
      return httpClient.delete(`/admin/materialtypes/${materialId}`)
    },
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      notifications.show({
        title: "Deleted",
        message: "Material type has been deleted",
        color: "green",
      })
      await queryClient.invalidateQueries(["materialTypes"])
    },
  })
}
